import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import SortObject from "../../../types/SortObject";
import OverheadExpenseModel, {
  CreateOverheadExpenseModel,
  UpdateOverheadExpenseModel,
} from "../../../viewModels/OverheadExpenses/OverheadExpenseModel";
import { OverheadExpensesFiltersType } from "../../../components/OverheadExpensesFilters";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  overheadExpenses: Array<OverheadExpenseModel>;
  total: number;
  pageSize: number;
  page: number;
  sort?: SortObject;
  filters?: OverheadExpensesFiltersType;
  searchFilterValue: string;
  overheadExpenseIdToEdit?: number;
  isEditDrawerLoading: boolean;
  isEditDrawerOpen: boolean;
} = {
  loading: true,
  loadingData: true,

  overheadExpenses: undefined!,
  total: undefined!,
  pageSize: 10,
  page: 1,

  searchFilterValue: "",

  isEditDrawerLoading: false,
  isEditDrawerOpen: false,
};

const overheadExpenseSlice = createSlice({
  name: "overheadExpenses",
  initialState,
  reducers: {
    loadOverheadExpenses(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadOverheadExpensesSuccess(state, action: PayloadAction<{ overheadExpenses: Array<OverheadExpenseModel>; total: number }>) {
      const { overheadExpenses, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.overheadExpenses = overheadExpenses;
      state.total = total;
    },
    loadOverheadExpensesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject; filters: OverheadExpensesFiltersType }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
      state.filters = action.payload.filters;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
    openEditDrawer(state, action: PayloadAction<number | undefined>) {
      state.overheadExpenseIdToEdit = action.payload!;
      state.isEditDrawerOpen = true;
    },
    closeEditDrawer(state) {
      if (!state.isEditDrawerLoading) {
        state.overheadExpenseIdToEdit = undefined!;
        state.isEditDrawerOpen = false;
      }
    },

    createOverheadExpense(state, _action: PayloadAction<CreateOverheadExpenseModel>) {
      state.isEditDrawerLoading = true;
    },
    createOverheadExpenseSuccess(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },
    createOverheadExpenseError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },

    updateOverheadExpense(state, _action: PayloadAction<UpdateOverheadExpenseModel>) {
      state.isEditDrawerLoading = true;
    },
    updateOverheadExpenseSuccess(state, action: PayloadAction<OverheadExpenseModel>) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
      const index = state.overheadExpenses.findIndex((x) => x.id === action.payload.id);
      state.overheadExpenses[index] = action.payload;
    },
    updateOverheadExpenseError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },

    deleteOverheadExpense(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
  },
});

export default overheadExpenseSlice;
